import { Component, OnInit } from '@angular/core';
import { RouterLinkInfoService } from 'src/app/services/router-link-info.service';

@Component({
  selector: 'app-aexpense-master',
  templateUrl: './aexpense-master.component.html',
  styleUrls: ['./aexpense-master.component.css']
})
export class AExpenseMasterComponent implements OnInit {

  constructor(private routerinfoservice: RouterLinkInfoService) { }

  ngOnInit() {
  }
  onActivate(componentRef) {
    try {
      var currentUrl = window.location.pathname;
      // var me =  componentRef.getPageName();
      // this.CData =me;
      $('#breadItem').text(this.routerinfoservice.getPageName(currentUrl));
    }
    catch (ex) {
      console.log('Not set');
    }
  }
}
